import React, { useState } from "react";
import { useIntl } from "react-intl";
import { IconName } from "../../../../globalTypes";
import EwaButton2 from "../EwaButtons/EwaButton/EwaButton2";
import Filter from "../Filter";
import muiIconNames from "./muiIconNames";
import SelectIcon from "./SelectIcon";
import { Container, IconsList } from "./styles";

export type IconSelectorProps = {
  onIconSelect: (iconName: IconName) => void;
};

const IconSelector = ({ onIconSelect }: IconSelectorProps) => {
  const intl = useIntl();
  const [icons, setIcons] = useState<IconName[]>(muiIconNames);

  return (
    <Container>
      <Filter
        placeholder={intl.formatMessage({ id: "segments.find_icon" })}
        searchArr={muiIconNames}
        callback={setIcons}
      />
      <IconsList>
        {icons.map((icon) => (
          <SelectIcon iconName={icon} selectIcon={onIconSelect} key={icon} />
        ))}
      </IconsList>
      <EwaButton2
        onClick={() => onIconSelect("")}
        label={intl.formatMessage({ id: "segments.decline_icon" })}
      />
    </Container>
  );
};

export default IconSelector;
